export const COMPONENT_NAME = 'ResponsiveCollage';
